<template>
    <BarometerHero class="barometer-home__hero" :title="title" :image-url="imageUrl" :cta="cta" :breadcrumbs="breadcrumbs" />
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {useTranslation} from '#imports';
    import {BAROMETER_HOME} from '~/keys';
    import BarometerHero from '../BarometerHero.vue';

    const {t} = useTranslation();
    const {generalBarometer} = inject(BAROMETER_HOME)!;

    const title = t('barometer.banner.title');
    const imageUrl = `https://dam.malt.com/families/banner/mobile-big/default?w=500`;

    const cta = {url: '/who-are-you', label: t('barometer.banner.cta')};
    const breadcrumbs = [{url: `/`, label: t('barometer.breadcrumbs.home')}, {label: t('barometer.breadcrumbs.general')}];
</script>
